import React from 'react';
import { XCircle } from 'lucide-react';

// Shared presentational bits. Lives in its own module so App.js and LinksPage.js
// can both use them without importing each other in a cycle.

export const Spinner = () => (
    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
);

export const btnClass = (active) =>
    `text-sm font-semibold py-2 px-4 rounded-md flex items-center justify-center transition duration-200 ${
        active
            ? 'bg-green-600 text-white'
            : 'bg-gray-300 hover:bg-gray-400 text-gray-800 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-gray-200'
    }`;

export const ErrorBanner = ({ message }) => !message ? null : (
    <div className="bg-red-100 dark:bg-red-900/50 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-300 px-4 py-3 rounded-lg flex items-center gap-3 animate-fade-in">
        <XCircle size={20} />
        <span>{message}</span>
    </div>
);
